import { useAuth } from '../auth/useAuth'
import { Spinner } from './ui'

const BYPASS_AUTH = import.meta.env.VITE_BYPASS_AUTH === 'true'

// Takes children rather than a component prop so the protected subtree keeps
// its identity across re-renders. See ProtectedPage in App.jsx.
function ProtectedRoute({ children }) {
  if (BYPASS_AUTH) {
    return children
  }

  const { isLoading, isAuthenticated } = useAuth()

  // GoogleAdapter renders the login gate itself when the user is not
  // authenticated, so if we reach here unauthenticated we're mid-init.
  if (isLoading || !isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50">
        <div className="text-center">
          <Spinner size="lg" />
          <p className="mt-4 text-neutral-600">Signing you in...</p>
        </div>
      </div>
    )
  }

  return children
}

export default ProtectedRoute
